import React from 'react';
import parse from 'html-react-parser';

export default function PageHeaderDescription({headerDescription}) {
  return headerDescription && (<p className="app-main-description">{parse(headerDescription)}</p>);
}
